// Quote.js
export async function fetchQuotes(tickers) {
  const server = "https://app.cuetraders.com";
  const url = `${server}/api/get_price_quotes.php?tickers=${tickers.join(",")}`;

  console.log("Fetching quotes for:", tickers);

  try {
    const response = await fetch(url);
    const json = await response.json();
    return mapQuotes(json);
  } catch (error) {
    console.error("Quote fetch error:", error);
    return [];
  }
}

// Helper to map API response to stock objects
function mapQuotes(data) {
  const quotesArray = [];

  if (data && data.data) {
    data.data.forEach((quote, idx) => {
      const item = {
        idx,
        ticker: quote.symbol,
        Price: quote.close === "" ? quote.extended_hours_quote : quote.close,
        ChangeUSD: quote.close === "" ? quote.extended_hours_change : quote.change,
        ChangePercent: quote.close === "" ? quote.extended_hours_change_percent : quote.change_percent,
        PreviousClose: quote.previous_close,
        Volume: quote.volume,
        LastUpdate: quote.timestamp
      };

      quotesArray.push(item);
    });
  }

  return quotesArray;
}
